import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M60 40q40-10 80 0 10 16 0 30-40-10-80 0-10-14 0-30M56 74q44-4 88 0 14 26 4 56-18 38-48 40-30-2-48-40-10-30 4-56" }, null, -1),
    _createElementVNode("path", {
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "M100 80v50"
    }, null, -1)
  ]))]))
}
export default { render: render }